export class WebConferenceStateHelper {
    started = false;
    stopped = false;
    showEventInfo = false;
    initialized = false;
    left = false;
    connecting = false;
    needDeviceTest = false;
    banned = false;

    get isActive() {
        return this.started && !this.stopped;
    }

    get showPlayer(): boolean {
        return this.initialized || this.connecting;
    }

    get showDeviceTest() {
        return this.initialized && this.needDeviceTest;
    }

    stopDeviceTest() {
        this.needDeviceTest = false;
    }

}
